import React, { useEffect, useState } from 'react';

import {
  AUMainContainer,
  AUNavBar,
  AUNotificationHub,
  AUSideBar,
  AUValidateAccessProduct,
  PRODUCT_IDS,
  SIDEBAR_WIDTH,
  useSidebar,
} from '@assertiva/assertiva-ui';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Routes from '@routes';
import { changeMenu } from '@stores/layout';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useCrossProductParams } from '@src/hook/useCrossProductParams';

export default function Office({ children, width, path }) {
  useCrossProductParams();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [openSidebar, setOpenSidebar] = useState(false);
  // const openSidebar = useSelector(selectMenuIsOpen);

  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
    //TODO: Por algum motivo não é executado, verificar depois no assertiva-ui
    dispatch(changeMenu(!openSidebar));
  };

  const history = useHistory();

  useEffect(() => {
    setOpenSidebar(false);
    dispatch(changeMenu(false));
  }, [path, dispatch]);

  const { FEATURE_FLAG_SIDEBAR_NOVA_VERSAO } = useSidebar();

  useEffect(() => {
    window.root.style.setProperty(
      '--sidebarWidthOpen',
      FEATURE_FLAG_SIDEBAR_NOVA_VERSAO ? SIDEBAR_WIDTH.OPEN : '225px'
    );
    window.root.style.setProperty(
      '--sidebarWidthClosed',
      FEATURE_FLAG_SIDEBAR_NOVA_VERSAO ? SIDEBAR_WIDTH.CLOSED : '54px'
    );
  }, [FEATURE_FLAG_SIDEBAR_NOVA_VERSAO]);

  return (
    <AUMainContainer isSideBarOpen={openSidebar}>
      <AUNavBar
        handleClickIconButton={handleSidebar}
        isSidebarOpen={openSidebar}
        handleAfterLogout={() => {
          localStorage.clear();
          history.push('/');
        }}
        handleClickLogoIcon={() => history.push('/assinaturas')}
      />
      <AUSideBar
        routes={[...Routes()]}
        path={path}
        open={openSidebar}
        onClose={handleSidebar}
        onOpen={handleSidebar}
        variant={isMobile ? 'temporary' : 'permanent'}
        width={width}
      />

      <AUValidateAccessProduct productId={PRODUCT_IDS.ASSINATURAS}>
        <Box maxWidth={1118} mx="auto">
          <AUNotificationHub productId={PRODUCT_IDS.ASSINATURAS} />
        </Box>
        {children}
      </AUValidateAccessProduct>
    </AUMainContainer>
  );
}
